var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm._l(_vm.itemData, function (item, i) {
        return _c(
          "v-expansion-panel-content",
          {
            key: i,
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      !!item.SourceDetail
                        ? _c("span", [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "WaterQualityAnalyteGuidelineUnitMismatchErrorModal.guidelineShortName"
                                  )
                                ) + ":"
                              ),
                            ]),
                            _vm._v(
                              "\n        " +
                                _vm._s(item.SourceDetail.GuidelineShortName) +
                                "\n        "
                            ),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "WaterQualityAnalyteGuidelineUnitMismatchErrorModal.guidelineStandard"
                                  )
                                ) + ":"
                              ),
                            ]),
                            _vm._v(
                              "\n        " +
                                _vm._s(item.SourceDetail.GuidelineStandard) +
                                "\n        "
                            ),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "WaterQualityAnalyteLabResultUnitMismatchErrorModal.analyte"
                                  )
                                ) + ":"
                              ),
                            ]),
                            _vm._v(
                              "\n        " +
                                _vm._s(item.SourceDetail.AnalyteName) +
                                "\n      "
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              "\n        " + _vm._s(item.Message) + "\n      "
                            ),
                          ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          },
          [
            _vm._v(" "),
            !!item.SourceDetail
              ? _c(
                  "v-layout",
                  {
                    staticClass: "error-detail-body",
                    attrs: { row: "", wrap: "" },
                  },
                  [
                    _c(
                      "v-flex",
                      {
                        staticClass: "border-bottom border-right",
                        attrs: { xs4: "" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "WaterQualityAnalyteGuidelineUnitMismatchErrorModal.analyteUnitGroup"
                            )
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { staticClass: "border-bottom", attrs: { xs8: "" } },
                      [_vm._v(_vm._s(item.SourceDetail.AnalyteUnitGroup))]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      {
                        staticClass: "border-bottom border-right",
                        attrs: { xs4: "" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "WaterQualityAnalyteGuidelineUnitMismatchErrorModal.guidelineStandardUnit"
                            )
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { staticClass: "border-bottom", attrs: { xs8: "" } },
                      [_vm._v(_vm._s(item.SourceDetail.GuidelineStandardUnit))]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { staticClass: "border-right", attrs: { xs4: "" } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "WaterQualityAnalyteGuidelineUnitMismatchErrorModal.message"
                            )
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { xs8: "" } }, [
                      _vm._v(_vm._s(item.Message)),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("v-divider"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }